export default {
    computed:{
        getSliderCars(){
            let cars = [];
            if(this.$route.name === 'DealersCars'){
                cars = this.d.cars
            }else{
                cars = this.convertCars;
            }

            if(!cars){
                return [];
            }

            const lastSlider = cars.length;

            /*if(this.allAd && this.allAd.length > 0 && cars.length > 0
                && this.$device.mobile()){
                cars.splice(2, 0, {ad: true,...this.allAd[0]});
                const secondAd = this.allAd.length > 1 ? this.allAd[1]:this.allAd[0];
                cars.splice(lastSlider + 1, 0, {ad: true,...secondAd});
            }*/


            if(this.allAd && this.allAd.length > 0 && cars.length > 0
                && this.$device.mobile()){
                cars.splice(2, 0, {ad: true, empty: true});
                cars.splice(lastSlider + 1, 0, {ad: true, empty: true});
            }

            return cars;
        }
    }
}